import React from 'react';
import { FiMoon, FiSun } from 'react-icons/fi';

const Header = ({ theme = 'light', onToggleTheme }) => {
  const isDark = theme === 'dark';
  return (
    <header className="shrink-0 flex justify-end items-center gap-4 px-4 md:px-8 py-3 border-b border-line bg-page-80 backdrop-blur-md text-ink">
      <div className="flex items-center gap-2 shrink-0">
        <button
          type="button"
          className="p-2 rounded-md border border-line text-ink"
          aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
          onClick={onToggleTheme}
        >
          {isDark ? (
            <FiSun className="h-5 w-5" aria-hidden="true" />
          ) : (
            <FiMoon className="h-5 w-5" aria-hidden="true" />
          )}
        </button>
        <button
          type="button"
          className="px-4 py-2 border border-line rounded-full text-sm"
          onClick={() => {
            window.location = 'mailto:rikhi.ravinder@gmail.com';
          }}
        >
          Email Me
        </button>
      </div>
    </header>
  );
};

export default Header;
